const initState = {
  metaInfoofClients:{
    isLoading: true,
    data:{},
    error:""
  }
};

export default initState;
